export const api = {
  host: 'https://campussutra.api.flowsmart.ai'
};
